import { render, staticRenderFns } from "./Single.vue?vue&type=template&id=35de0468&scoped=true&"
import script from "./Single.vue?vue&type=script&lang=js&"
export * from "./Single.vue?vue&type=script&lang=js&"
import style0 from "../../style.css?vue&type=style&index=0&id=35de0468&prod&scoped=true&lang=css&"
import style1 from "./Single.vue?vue&type=style&index=1&id=35de0468&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35de0468",
  null
  
)

export default component.exports